import { render, staticRenderFns } from "./AdminSearchOrdersSearch.vue?vue&type=template&id=09864b8b&"
import script from "./AdminSearchOrdersSearch.vue?vue&type=script&lang=js&"
export * from "./AdminSearchOrdersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports